import { defineRule, configure } from 'vee-validate';
import {
  required,
  email,
  min,
  max,
  confirmed,
  numeric,
  alpha,
  alpha_spaces,
  min_value,
  max_value,
  between,
} from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('confirmed', confirmed);
defineRule('numeric', numeric);
defineRule('alpha', alpha);
defineRule('alpha_spaces', alpha_spaces);
defineRule('min_value', min_value);
defineRule('max_value', max_value);
defineRule('between', between);

configure({
  generateMessage: localize({ en }),
});
